<script type="text/ecmascript-6">

    import {mapGetters} from "vuex";

    export default {
        /**
         * The component's data.
         */
        data: () => ({
            showModal: false,
            id: null,
            project_name: null,
        }),

        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                isPreview: 'getIsPreview',
                ownPage: 'getOwnPage',
            })
        },
    }
</script>

<template>
    <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow" v-show="!isPreview">

        <!-- Sidebar Toggle (Topbar) -->
        <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
            <i class="fa fa-bars"></i>
        </button>

        <!-- Topbar Navbar -->
        <ul class="navbar-nav ml-auto">

            <!-- Nav Item - User Information -->
            <li class="nav-item no-arrow">
                <a class="nav-link" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{ ownPage.name }}</span>
                    <img class="img-profile rounded-circle" :src="ownPage.picture">
                </a>
            </li>

        </ul>

    </nav>
</template>
